<template>
  <div>
    <vs-col>
      <vs-row vs-type="flex" vs-w="3" vs-sm="3" vs-xs="12">
        <h1 class="primary font-bold" style="color: #555555">Events</h1>
      </vs-row>

      <div class="mt-6">
        <div class="iframe-container">
          <iframe
            id="member-events-iframe"
            ref="memberEventsIframe"
            src="https://memberevents.freshclinics.com/app-embed"
            frameborder="0"
            allowfullscreen=""
            allowtransparency="true"
            style="width:100%; height:100%; border:0; min-height:100vh!important"
          ></iframe>
        </div>
      </div>
    </vs-col>
  </div>
</template>

<script>
export default {
  methods: {
    sendAuthContextToHubSpot() {
      try {
        const iframe = document.getElementById('member-events-iframe');
        if (!iframe) {
          console.warn('HubSpot events iframe not found');
          return;
        }

        // Get user ID from store or localStorage
        const user = this.$store.state.AppActiveUser;
        const appUserId = (user && (user.id || user._id || user.uid)) || null;

        // Get token from localStorage if available
        const token = localStorage.getItem(
          `${process.env.VUE_APP_ACCESS_TOKEN_NAME}AccessToken`
        );

        // Only send message if we have a logged-in user
        if (appUserId) {
          const message = {
            type: 'AUTH_CONTEXT',
            appUserId: appUserId,
          };

          // Add token if available
          if (token) {
            message.token = token;
          }

          // Send postMessage to HubSpot domain
          iframe.contentWindow.postMessage(
            message,
            'https://memberevents.freshclinics.com'
          );

        } else {
          console.warn('No user ID found, skipping HubSpot auth context');
        }
      } catch (error) {
        console.error('Error sending auth context to HubSpot:', error);
      }
    },
    handleIframeLoad() {
      // Wait a bit for iframe to be fully ready
      this.$nextTick(() => {
        setTimeout(() => {
          this.sendAuthContextToHubSpot();
        }, 500);
      });
    },
  },
  mounted() {
    // Add event listener for iframe load
    const iframe = this.$refs.memberEventsIframe;
    if (iframe) {
      iframe.addEventListener('load', this.handleIframeLoad);
    }
  },
  beforeDestroy() {
    // Clean up event listener
    const iframe = this.$refs.memberEventsIframe;
    if (iframe) {
      iframe.removeEventListener('load', this.handleIframeLoad);
    }
  },
};
</script>

<style scoped>
/* Responsive iframe container */
.iframe-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100vh;
}

</style>
